//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid';

const stringOptions = [
  'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
  ].reduce((acc, opt) => {
  for (let i = 1; i <= 5; i++) {
    acc.push(opt + ' ' + i)
  }
  return acc
}, [])

export default {
    data () {
        return {
            shape: '',
            current: 3, 
            dense: true,  

            form : {
              id : '',
              m_provinsi : '',
              m_kabupaten : '',
              m_kecamatan : '',
              m_desa_kelurahan : '',
              kd_desa_kelurahan : '',
              uraian : '',
              m_type_desa_kelurahan : null,
              createdAt : '',
              uniqid : ''
            },
          
            list_data : [],

            page_limit : 8,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,

            UMUM : UMUM,
            WILAYAH : WILAYAH,
          }
    },
    methods: {
      getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DATAMASTER_DES_KEL + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;
                this.$store.commit("hideLoading");
                // console.log(res_data);
        });
      },


      addData : function(number) {
        this.form.uniqid = uniqid();
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_DATAMASTER_DES_KEL + "addData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });


      },


      editData : function(){
        fetch(this.$store.state.url.URL_DATAMASTER_DES_KEL + "editData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getView();
        });
      },

      removeData : function(E){
        fetch(this.$store.state.url.URL_DATAMASTER_DES_KEL + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
        });

      },
      selectData : function(data){

          this.form.wilayah = data.des_kel.wilayah;
          this.form.kab_kota = data.des_kel.kab_kota;
          this.form.kecamatan = data.des_kel.kecamatan;

          this.form.id = data.des_kel.id;
          this.form.uraian = data.des_kel.uraian;
          this.form.createdAt = data.des_kel.createdAt;
          this.form.uniqid = data.des_kel.uniqid;

          this.getWilayah.getKab(this.form.wilayah);
          this.getWilayah.getKec(this.form.kab_kota);


      },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


    // ====================================== PAGINATE ====================================

      notif_berhasil () { 
        this.$q.notify({
          message: "Data berhasil dimasukan",
          color: 'green',
          icon: 'fa fa-check',
          timeout: 500,
        })
      },
      notif_berhasil_menghapus () { 
        this.$q.notify({
          message: 'Berhasil menghapus data',
          color: 'green',
          icon: 'fa fa-check',
          timeout: 500,
        })
      },
      notif_edit () { 
        this.$q.notify({
          message: 'Berhasil mengedit data',
          color: 'green',
          icon: 'fa fa-check',
          timeout: 500,
        })
      },
      notif_gagal () {
        this.$q.notify({
          message: this.pesanGagal,
          color: 'red',
          icon: 'fa fa-exclamation-triangle',
          timeout: 500,
        })
      },
 

      filterFn (val, update, abort) {
        // call abort() at any time if you can't retrieve data somehow
        setTimeout(() => {
          update(
            () => {
              if (val === '') {
                this.options = stringOptions
              }
              else {
                const needle = val.toLowerCase()
                this.options = stringOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
              }
            },

            // next function is available in Quasar v1.7.4+;
            // "ref" is the Vue reference to the QSelect
            ref => {
              if (val !== '' && ref.options.length > 0) {
                ref.setOptionIndex(-1) // reset optionIndex in case there is something selected
                ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
              }
            }
          )
        }, 300)
      },      
      abortFilterFn () {
        // console.log('delayed filter aborted')
      },
      counterLabelFn ({ totalSize, filesNumber, maxFiles }) {
            return `${filesNumber} files of ${maxFiles} | ${totalSize}`
          }      
    },
    mounted () {
      this.WILAYAH.getProv();
    },
}
